import util from '../util';

export const FORMS = 'FORMS';
export const FORM = 'FORM';
export const PRINTED_FORMS = 'PRINTED_FORMS';
export const CREATE_FORM = 'CREATE_FORM';
export const UPDATE_FORM = 'UPDATE_FORM';
export const EDIT_FORM = 'EDIT_FORM';
export const DELETE_FORM = 'DELETE_FORM';
export const RESET_FORM = 'RESET_FORM';
export const IMPORT_CRM_FORMS = 'IMPORT_CRM_FORMS';
export const LOAD_DEAL_FORMS = 'LOAD_DEAL_FORMS';

export const FORM_REQUEST = util.requestType(FORM);
export const FORM_SUCCESS = util.successType(FORM);
export const FORM_FAILURE = util.failureType(FORM);

export const FORMS_REQUEST = util.requestType(FORMS);
export const FORMS_SUCCESS = util.successType(FORMS);
export const FORMS_FAILURE = util.failureType(FORMS);

export const CREATE_FORM_REQUEST = util.requestType(CREATE_FORM);
export const CREATE_FORM_SUCCESS = util.successType(CREATE_FORM);
export const CREATE_FORM_FAILURE = util.failureType(CREATE_FORM);

export const UPDATE_FORM_REQUEST = util.requestType(UPDATE_FORM);
export const UPDATE_FORM_SUCCESS = util.successType(UPDATE_FORM);
export const UPDATE_FORM_FAILURE = util.failureType(UPDATE_FORM);

export const EDIT_FORM_REQUEST = util.requestType(EDIT_FORM);
export const EDIT_FORM_SUCCESS = util.successType(EDIT_FORM);
export const EDIT_FORM_FAILURE = util.failureType(EDIT_FORM);

export const DELETE_FORM_REQUEST = util.requestType(DELETE_FORM);
export const DELETE_FORM_SUCCESS = util.successType(DELETE_FORM);
export const DELETE_FORM_FAILURE = util.failureType(DELETE_FORM);

export const IMPORT_CRM_FORMS_REQUEST = util.requestType(IMPORT_CRM_FORMS);
export const IMPORT_CRM_FORMS_SUCCESS = util.successType(IMPORT_CRM_FORMS);
export const IMPORT_CRM_FORMS_FAILURE = util.failureType(IMPORT_CRM_FORMS);

export const PRINTED_FORMS_REQUEST = util.requestType(PRINTED_FORMS);
export const PRINTED_FORMS_SUCCESS = util.successType(PRINTED_FORMS);
export const PRINTED_FORMS_FAILURE = util.failureType(PRINTED_FORMS);

export const LOAD_DEAL_FORMS_REQUEST = util.requestType(LOAD_DEAL_FORMS);
export const LOAD_DEAL_FORMS_SUCCESS = util.successType(LOAD_DEAL_FORMS);
export const LOAD_DEAL_FORMS_FAILURE = util.failureType(LOAD_DEAL_FORMS);
